export const GroupMeetingPatientAttendanceType = {
    noShow: 'noShow',
    present: 'present',
} as const;

export type GroupMeetingPatientAttendance =
    (typeof GroupMeetingPatientAttendanceType)[keyof typeof GroupMeetingPatientAttendanceType];
